import styled from 'styled-components';

import { MAIN_BLUE } from '../../styles/Colors';

import { below, above } from '../../utils/Breakpoints';
export const ContactContainer = styled.div`
  margin: 75px auto;
  width: 90%;
  height: 500px;
  display: flex;
  align-items: center;
`;

export const Card = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 500px;
  margin: 0 10px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.5);
  ${below.med`
    flex-direction:column-reverse`}
`;

export const LeftCard = styled.div`
  width: 50%;
  flex-grow: 1;
  height: auto;
  border-radius: 10px;
  padding: 10px;
  ${below.med`
    width:100%;
    `}
`;

export const Map = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export const RightCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  flex-grow: 1;
  padding: 10px;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  ${below.med`
    width:100%;
    height:50%
    `}
`;

export const TitleContact = styled.span`
  font-size: 36px;
  color: ${MAIN_BLUE};
  font-weight: bold;
`;

export const EachContact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const IconContact = styled.img`
  color: ${MAIN_BLUE};
  width: 30px;
`;
export const TextContact = styled.span`
  font-size: 18px;
`;

export const Illustration = styled.img`
  max-height: 40%;
  margin-top: 5%;
  width: 80%;
  resize: horizontal;
  position: relative;
  bottom: 0;
  ${below.med`
    display:none;
  `}
`;
